import { UserManagerSettings } from 'oidc-client';
import * as Oidc from 'oidc-client';
import { normalizeUrl } from '../utils/utils';

/**
 * OidcConfig est l'objet à utiliser dans les applications clientes pour configurer la librairie
 */

export interface OidcConfigParameters {
  app_name?: string; // * nom de l'application pour le client id cas
  home?: string; // * page d'accueil
  callback?: string; // * page de retour de la connexion
  post_logout_redirect_uri?: string; // * page de retour de la déconnexion SSO
  logout_success_uri?: string; // * page vers laquelle l'utilisateur sera redirigé après logout
  redirect?: boolean;
  provider?: string; // * provider principal
  providers?: string[]; // * liste des providers qui seront configurée.
  log_level?: string; // * niveau de debug pour oidc
  userManagers?: { [id: string]: Oidc.UserManagerSettings; }; // autogénéré
  subdomain?: string;
  useExtensions?: boolean;  // Permet à une librairie tierce d'effectuer des traitements
                            // durant l'authentification de l'utilisateur.
                            // - si true: la lib émet l'action ngrx AuthCoExtensionBeforeAuthSuccess
                            //   cette action devra être gérée côté utilisateur du module ng-auth
                            //   pour effectuer des traitements d'initialisation
                            //   une fois ces traitements effectués, la librairie doit
                            //   émettre l'action AuthCoExtensionBeforeAuthSuccessResponse
                            //   pour que l'authentification soit finalisée
                            // - si false, l'évènement AuthCoExtensionBeforeAuthSuccess n'est pas
                            //   émis
                            // par défaut false
}

export class OidcConfig implements OidcConfigParameters {
  app_name: string;
  home: string;
  callback: string;
  redirect?: boolean;
  logout_success_uri?: string;
  private _post_logout_redirect_uri?: string;
  provider: string;
  providers: string[];
  log_level: string;
  userManagers: { [id: string]: Oidc.UserManagerSettings; };
  subdomain: string;
  useExtensions: boolean;

  get post_logout_redirect_uri() {
    return this.userManagers[this.provider].post_logout_redirect_uri;
  }

  constructor({ app_name = 'pegase', subdomain = 'dev',
    home = '/', callback = '/auth/auth-callback', post_logout_redirect_uri = '/auth/logout-callback',
    provider = 'cas_pcscol', providers = ['cas_pcscol'],
    log_level = 'ERROR', userManagers, redirect = false,
    logout_success_uri = '', useExtensions: useExtensions = false,
  }: OidcConfigParameters = {}) {
    this.app_name = app_name;
    this.home = home;
    this.logout_success_uri = (logout_success_uri ? logout_success_uri : this.home);
    this.callback = callback;
    this.redirect = redirect;
    this._post_logout_redirect_uri = post_logout_redirect_uri;
    this.provider = provider;
    this.subdomain = subdomain;
    this.providers = providers;
    this.log_level = log_level;
    this.userManagers = userManagers === null || userManagers === undefined ? this.buildOidcUserManagerSettings() : userManagers;
    if (Object.keys(this.userManagers).length === 1) {
      this.provider = Object.keys(this.userManagers)[0];
    }
    this.useExtensions = useExtensions;
  }

/**
 * Conf to  build user manager settings
 */
private buildOidcUserManagerSettings() {
  console.warn(`Configuration automatique dépréciée, valoriser la propriété userManagers de OidcConfig`);
  const isLocal = window.location.hostname === ('localhost') || window.location.hostname.startsWith('127.0.0.');
  // Build user managers
  const userManagers: { [id: string]: UserManagerSettings } = {};
  this.providers = this.providers.length > 0 ? this.providers : ['default'];
  this.providers.forEach(elem => {
    // default object avec les propriétés communes aux différents providers
    // === DEFAULT
    let conf: UserManagerSettings = {
      authority: 'authority url',
      client_id: 'CLIENT ID',
      response_type: 'id_token token',
      scope: 'openid profile',
      filterProtocolClaims: true,
      loadUserInfo: true,
      redirect_uri: `${window.location.protocol}//${window.location.host}${this.callback}`,
      post_logout_redirect_uri: normalizeUrl(this._post_logout_redirect_uri!),
      silent_redirect_uri: `${window.location.protocol}//${window.location.host}/auth/auth-silent`,
      automaticSilentRenew: true,
    };

    // CAS_PCSCOL
    if ( elem === 'cas_pcscol' ) {
      const regex = /^[^.]+(\..+\..+\..+)$/;
      let domain = `.${this.subdomain}.pc-scol.fr`;
      if (window.location.hostname.match(regex)) {
        domain = window.location.hostname.replace(regex, '$1');
      }
      conf = {
        ...conf,
        authority: `https://cas${domain}/cas/oidc/`,
        client_id: isLocal ? 'pegase-local' : this.app_name,
      };
    }

    // // GOOGLE
    // if ( elem === 'google' ) {
    //   conf.authority = 'https://accounts.google.com/';
    //   conf.client_id = 'S3CR3T.apps.googleusercontent.com';
    // }

    // // FRANCE CONNECT
    // if ( elem === 'franceconnect' ) {
    //   conf.authority =      'https://fcp.integ01.dev-franceconnect.fr/api/v1/';
    //   conf.client_id =      'S3CR3T';
    //   conf.response_type =  'id_token'; // TODO implicit flow fails with france connect
    //   conf.metadata = {
    //     issuer:                 'https://fcp.integ01.dev-franceconnect.fr',
    //     authorization_endpoint: 'https://fcp.integ01.dev-franceconnect.fr/api/v1/authorize',
    //     token_endpoint:         'https://fcp.integ01.dev-franceconnect.fr/api/v1/token',
    //     userinfo_endpoint:      'https://fcp.integ01.dev-franceconnect.fr/api/v1/userinfo',
    //     end_session_endpoint:   'https://fcp.integ01.dev-franceconnect.fr/api/v1/logout',
    //     // jwks_uri:               '',
    //     // extraQueryParams: {
    //       //   nonce: 'test', // TODO Hack to force nonce
    //       // }
    //     };
    //  }
      userManagers[elem] = <UserManagerSettings> conf;
  });

  return userManagers;
}




}

